import {
  REMOVE_IMAGE_TOOLTIP,
  REMOVE_PDF_TOOLTIP,
  UPLOAD_FILE_INPUT_ID,
} from 'components/AiMode/constants';
import styles from './styles.module.scss';
import { PdfFileType, ImageType } from 'types';
import { Button } from 'packages/radiant-react/button';
import { getSupportedUploadMimeType } from 'utils/aiChat';
import { Typography } from 'packages/radiant-react/typography';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';
import { Icon, IconColor, IconID, IconSize } from 'packages/radiant-react/icon';

function UploadView({
  userPdfAndImages,
  handleDelete,
  handleUpload,
}: {
  userPdfAndImages: { pdfs: PdfFileType[]; images: ImageType[] };
  handleDelete: (id: string, type: 'pdf' | 'image') => void;
  handleUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  return (
    <Vertical className={styles['main-container']}>
      <Vertical className={styles['container']}>
        <Horizontal className={styles['container-preview']}>
          {userPdfAndImages.images.map((img) => (
            <Horizontal className={styles['preview-item']} key={img.id} vAlignContent="center">
              <Button
                type="secondary"
                size="m"
                icon={IconID.CROSS_CIRCLE}
                iconColor={IconColor.DARKGRAY}
                onClick={() => handleDelete(img.id, 'image')}
                className={styles['preview-item-delete']}
                tooltip={REMOVE_IMAGE_TOOLTIP}
              />
              <img src={img.content} alt="image" className={styles['preview-item-image']} />
              <Vertical className={styles['preview-item-content']} vAlignContent="center">
                <Typography variant="p" className={styles['preview-item-name']}>
                  {img.name}
                </Typography>
                <Typography variant="body-normal" className={styles['preview-item-size']}>
                  {img.size}
                </Typography>
              </Vertical>
            </Horizontal>
          ))}
          {userPdfAndImages.pdfs.map((pdf) => (
            <Horizontal className={styles['preview-item']} key={pdf.id} vAlignContent="center">
              <Button
                type="secondary"
                size="m"
                icon={IconID.CROSS_CIRCLE}
                iconColor={IconColor.BLACK}
                onClick={() => handleDelete(pdf.id, 'pdf')}
                className={styles['preview-item-delete']}
                tooltip={REMOVE_PDF_TOOLTIP}
              />
              <Icon
                id={IconID.DOC_SEARCH_PDF}
                size={IconSize.MEDIUM}
                className={styles['preview-item-image']}
              />
              <Vertical className={styles['preview-item-content']} vAlignContent="center">
                <Typography variant="p" className={styles['preview-item-name']}>
                  {pdf.name}
                </Typography>
                <Typography variant="body-normal" className={styles['preview-item-size']}>
                  {pdf.size}
                </Typography>
              </Vertical>
            </Horizontal>
          ))}
        </Horizontal>
        <Horizontal className={styles['upload-input']}>
          <input
            type="file"
            onChange={handleUpload}
            accept={getSupportedUploadMimeType()}
            multiple
            id={UPLOAD_FILE_INPUT_ID}
          />
        </Horizontal>
      </Vertical>
    </Vertical>
  );
}

export default UploadView;
